import React from 'react'
import KeyFeatureComponent from '../../home/KeyFeatureComponent/KeyFeatureComponent'

function Why_Profcyma() {
  return (
   <>
   <KeyFeatureComponent />
   </>
  )
}

export default Why_Profcyma